export default __webpack_public_path__ + "static/w3-a7446b090790c61e91375c8fa6ac9331.jpg";